module.exports = __webpack_public_path__ + "media/images/panels/panel-3-top-service-484b04c5e2b3c631f5d976d4ddaf4c4f.jpg";